/*
 * Copyright (c) 2021. Sanish Manandhar
 * All Rights Reserved
 */
import {
  TICKET_CLEAN_REQUEST,
  TICKET_UPSERT_REQUEST,
  TICKET_UPSERT_REQUEST_SUCCESS,
  TICKET_UPSERT_REQUEST_FAILURE,
  SINGLE_TICKET_FETCH_REQUEST,
  SINGLE_TICKET_FETCH_REQUEST_SUCCESS,
  SINGLE_TICKET_FETCH_REQUEST_FAILURE,
  TICKET_FETCH_REQUEST,
  TICKET_FETCH_REQUEST_SUCCESS,
  TICKET_FETCH_REQUEST_FAILURE,
  FETCH_STATUS_DROPDOWN_REQUEST,
  FETCH_STATUS_DROPDOWN_REQUEST_FAILURE,
  FETCH_STATUS_DROPDOWN_REQUEST_SUCCESS,
  FETCH_COMMENT_REQUEST,
  FETCH_COMMENT_REQUEST_FAILURE,
  FETCH_COMMENT_REQUEST_SUCCESS,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  singlePayload: [],
  singleLoading: false,
  singleErrors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  statusDropdown: [],
  statusDropdownErrors: {},
  statusDropdownLoading: false,
  unreadCount: [],
  unreadCountLoading: false,
  unreadCountErrors: {},
  commentPayload: [],
  commentErrors: {},
  commentLoading: false,
  commentPagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const supportV2Reducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TICKET_UPSERT_REQUEST:
    case TICKET_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TICKET_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case TICKET_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
        },
      });

    case TICKET_UPSERT_REQUEST_FAILURE:
    case TICKET_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SINGLE_TICKET_FETCH_REQUEST:
      return Object.assign({}, state, {
        singleLoading: true,
      });

    case SINGLE_TICKET_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleLoading: false,
        singlePayload: action.data,
        singleErrors: {},
      });

    case SINGLE_TICKET_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleLoading: false,
        singleErrors: action.error,
        singlePayload: undefined,
      });

    case FETCH_STATUS_DROPDOWN_REQUEST:
      return Object.assign({}, state, {
        statusDropdownLoading: true,
      });

    case FETCH_STATUS_DROPDOWN_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        statusDropdownLoading: false,
        statusDropdown: action.data,
        statusDropdownErrors: {},
      });

    case FETCH_STATUS_DROPDOWN_REQUEST_FAILURE:
      return Object.assign({}, state, {
        statusDropdownLoading: false,
        statusDropdownErrors: action.error,
      });

    case TICKET_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    case FETCH_COMMENT_REQUEST:
      return Object.assign({}, state, {
        commentLoading: true,
      });

    case FETCH_COMMENT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        commentPayload: action.data,
        commentLoading: false,
        commentErrors: {},
        commentPagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
        },
      });

    case FETCH_COMMENT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        commentLoading: false,
        commentErrors: action.error,
      });

    default:
      return state;
  }
};

export default supportV2Reducer;
